import React from "react";

const TONES = {
  // Frosted panel on the navy page (default).
  glass: "bg-white/[0.06] border border-white/10 backdrop-blur-sm",
  // Opaque deep-navy panel (headers, sheets, modals).
  solid: "bg-header border border-white/10",
  // Highlighted panel (premium, selected).
  accent: "bg-mainButton/10 border border-mainButton/40",
};

const PADS = { none: "", sm: "p-4", md: "p-5 md:p-6", lg: "p-6 md:p-8" };

const Card = ({
  as: Tag = "div",
  tone = "glass",
  pad = "md",
  className = "",
  children,
  ...rest
}) => (
  <Tag
    className={`rounded-2xl ${TONES[tone] || TONES.glass} ${PADS[pad] ?? PADS.md} ${className}`}
    {...rest}
  >
    {children}
  </Tag>
);

export default Card;
